import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    API_REPORT_URL = config.serverAddress + ':' + config.serverPort + '/report/';

    constructor(private http: HttpClient) { }

    create(idContract: string | null, idChecklist: string | null) {
        return this.http.get(this.API_REPORT_URL + 'create/' + idContract + '/' + idChecklist, { responseType: 'blob'});
    }

    createXLS(idContract: string | null, idChecklist: string | null) {
        return this.http.get(this.API_REPORT_URL + 'xls/' + idContract + '/' + idChecklist, { responseType: 'blob'});
    }
}
